import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { FormStepContext } from './FormStepContext';
import ButtonBack from '../form-buttons/ButtonBack';
import ButtonNext from '../form-buttons/ButtonNext';

const FourthStep = () => {
  const {
    currentStep,
    register,
    watch,
    projectType,
    projectDomain,
    reset,
    getValues,
    activeStep,
  } = useContext(FormStepContext);

  const [currentProjectType, setCurrentProjectType] = useState('');
  const [currentProjectDomain, setCurrentProjectDomain] = useState('');
  const { loading, success, failed, lists } = useSelector((s) => s.modules);
  const [selectedModules, setSelectedModules] = useState([]);

  const values = getValues();
  const watchedModule = watch(`modules`);

  useEffect(() => {
    if (
      activeStep === currentStep.id &&
      (currentProjectType != projectType ||
        currentProjectDomain != projectDomain) &&
      !loading &&
      success &&
      !failed
    ) {
      const list = [];
      const defaultCheckedValues = [];

      if (lists.recommended.length > 0) {
        lists.recommended.forEach((item) => {
          defaultCheckedValues.push(item._id);

          const newItem = {
            ...item,
            recommended: true,
          };
          list.push(newItem);
        });
      }
      list.push(...lists.optional);

      setSelectedModules(list);
      reset({ ...values, modules: defaultCheckedValues });
      setCurrentProjectType(projectType);
      setCurrentProjectDomain(projectDomain);
    }
  }, [
    projectType,
    projectDomain,
    currentProjectType,
    currentProjectDomain,
    activeStep,
    currentStep,
    lists,
    loading,
    success,
  ]);

  return (
    <>
      <div className="laForm__stage-item__sticky-header">
        <div className="laForm__stage-badge">Stage {currentStep.id}</div>
        <h2>
          Project <strong>modules</strong>
        </h2>
      </div>
      <div className="laForm__stage-item__wrapper">
        {selectedModules.length > 0 && (
          <fieldset className="row-fieldset">
            <legend>
              Select the key features your software project will include
            </legend>
            {selectedModules.map((item) => (
              <div key={item._id} className="row-btn-group">
                <input
                  type="checkbox"
                  value={item._id}
                  id={item._id}
                  className="hidden-input"
                  {...register('modules')}
                />
                <label htmlFor={item._id} className="ic-check">
                  <span>{item.name}</span>
                  {item.description && <span>{item.description}</span>}
                  {item.recommended && (
                    <div className="label-badge">
                      <span>Recommended</span>
                    </div>
                  )}
                </label>
              </div>
            ))}
          </fieldset>
        )}
      </div>

      <div className="laForm__stage-item__btns on-modules-step">
        <ButtonBack stepId={currentStep.id} />
        <ButtonNext
          stepId={currentStep.id}
          isDisabled={!watchedModule || watchedModule.length === 0}
          buttonId={`${currentStep.id}-project-modules`}
        />
      </div>
    </>
  );
};

export default FourthStep;

FourthStep.propTypes = {
  currentStep: PropTypes.object,
  projectType: PropTypes.string.isRequired,
  projectDomain: PropTypes.string.isRequired,
  activeStep: PropTypes.number,
};
